export const CURRENCY_SYMBOL = '$'
export const SEGMENT_PRICE_TEST_COOKIE = 'hec_priceTestVariant'
export const TEN_MINUTES_IN_MS = 10 * 60 * 1000

export interface BuilderOptions {
    model: string
    entry?: string
    apiKey?: string
    cachebust?: boolean
    userAttributes?: Record<string, any>
    options?: Record<string, any>
}
